import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { FormattedNumber } from "react-intl";
import { If, DescriptionField } from "components/support";
import { observer } from "mobx-react";
import { UnitLabels } from "core/enum";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";
import { fn } from "util";
import { Divider } from "material-ui";
import style from "./style";
import { images } from "assets";

class GeneralInfo extends Component {
  linkedOptionalGroupsMap = linkedOptionalsGroup => {
    return linkedOptionalsGroup.map((optional, i) => (
      <Row center="xs" middle="xs" key={i}>
        <Col xs={2}>
          <If test={!!optional.enabled}>
            <Icon className="row-icon black-icon">done</Icon>
          </If>
          <If test={!!!optional.enabled}>
            <Icon className="row-icon red-icon">clear</Icon>
          </If>
        </Col>
        <Col xs>
          <DescriptionField value={optional.name} />
        </Col>
        <Col xs>
          <FormattedNumber value={fn.centsToReal(optional.value)} format="BRL">
            {value => <DescriptionField value={value} />}
          </FormattedNumber>
        </Col>
        <Col xs>
          <DescriptionField value={optional.mandatory_quantity || "Não tem"} />
        </Col>
        <Col xs>
          <DescriptionField value={optional.limited_value || "Não tem"} />
        </Col>
      </Row>
    ));
  };

  handleLabel(type) {
    let label = `Código de Barras`;

    if (type === "gtin") {
      label = "GTIN";
    } else if (type === "pack_barcode") {
      label = "GTIN/Embalagem";
    }

    return label;
  }

  render() {
    const { className, product, linkedOptionalGroups } = this.props;
    const lgValue = product.barcodes.length > 1 ? 6 : 12;

    return (
      <div className={`${className} grid-container`}>
        <Row bottom="xs">
          <Col xs={12} lg={4} style={{ marginTop: 6, textAlign: "center" }}>
            <img
              src={product.image_url || images.placeholder}
              style={{ width: 160, height: 90 }}
              alt="Imagem do produto"
            />
          </Col>
          <Col xs={12} lg={8}>
            <DescriptionField label="Nome do Produto" value={product.name} />
            <DescriptionField label="Url da Imagem" value={product.image_url} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={4}>
            <DescriptionField label="Código" value={product.code} />
          </Col>
          <Col xs={12} lg={4}>
            <DescriptionField
              label="Unidade de Medida"
              value={(UnitLabels[product.unit_label] || {}).name}
            />
          </Col>
          <Col xs={12} lg={4}>
            <DescriptionField label="Categoria" value={product.categoryName} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <FormattedNumber
              value={product.getCostValue().div(100)}
              format="BRL"
            >
              {value => (
                <DescriptionField label="Preço de Compra" value={value} />
              )}
            </FormattedNumber>
          </Col>
          <Col xs={12} md={4}>
            <DescriptionField
              label="Margem de Lucro"
              value={`${product.getProfit().toFixed(2)}%`}
            />
          </Col>
          <Col xs={12} md={4}>
            <FormattedNumber
              value={product.getSellValue().div(100)}
              format="BRL"
            >
              {value => (
                <DescriptionField label="Preço de Venda" value={value} />
              )}
            </FormattedNumber>
          </Col>
        </Row>
        <Row>
          {product.barcodes.map((barcode, index) => (
            <Col key={index} xs={12} lg={lgValue}>
              <DescriptionField
                label={this.handleLabel(barcode.type)}
                value={barcode.code}
              />
            </Col>
          ))}
        </Row>

        <Divider className="mv-md" />

        <If test={linkedOptionalGroups.length > 0}>
          <Row middle="xs" center="xs" className="mb-md">
            <Col xs>
              <Typography type="title">
                Grupos de Opcionais vinculados à este produto
              </Typography>
            </Col>
          </Row>
        </If>

        <Row middle="xs" center="xs">
          <Col xs={12}>
            <If test={!linkedOptionalGroups.length}>
              <Row middle="xs" className="full-height">
                <Col xs>
                  <Typography type="headline">
                    Não há Grupos de Opcionais associados à este produto
                  </Typography>
                </Col>
              </Row>
            </If>

            <If test={linkedOptionalGroups.length}>
              <Row middle="xs" center="xs" className="mb-sm">
                <Col xs={2}>
                  <Tooltip
                    key="tooltip-top-enable-opt-groups"
                    title="Edite o produto e em seguida gerencie os grupos de opcionais para habilitar ou desabilitá-los."
                    placement="top"
                  >
                    <div className="tooltip-div">
                      <Row center="xs" className="full-width">
                        <Col xs={2} />
                        {/* empty to set offset of row with cols, better for alignment */}
                        <Col xs={3}>
                          <Icon className="tooltip-icon">info</Icon>
                        </Col>
                        <Col xs={5}>
                          <Typography type="subheading">Habilitada</Typography>
                        </Col>
                      </Row>
                    </div>
                  </Tooltip>
                </Col>
                <Col xs>
                  <Typography type="subheading">Nome</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Valor por Opcional</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Qtd Obrigatória</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Qtd Máxima</Typography>
                </Col>
              </Row>

              {this.linkedOptionalGroupsMap(linkedOptionalGroups)}
            </If>
          </Col>
        </Row>

        <Row>
          <Divider className="mv-md full-width" />
        </Row>
      </div>
    );
  }
}

export default style(observer(GeneralInfo));



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/general-info/index.jsx